import React, { PureComponent } from 'react';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';

interface RouterRedirectProps extends RouteComponentProps {
  to: string
}

class RouterRedirect extends PureComponent<RouterRedirectProps> {

  render() {
    const { to, location: { search, hash, pathname, state } } = this.props;
    const oldState: any = state;

    return (
      <Redirect
        { ...this.props }
        to={
          {
            pathname: to,
            search: search,
            hash: hash,
            state: { ...oldState, prevPath: pathname }
          }
        }
      />
    );
  }

}

export default withRouter(RouterRedirect);
